import { css  } from '@emotion/core'
import { mq } from '../../cssInJs'

export default {
  top: css(mq({
    //height: [44, null, 80],
    height: [44, null, 110],
    background: 'white',
    position: 'fixed',
    width: '100%',
    zIndex: '999',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.3s'
  })),
  topScrolled: css(mq({
    height: [44, null, 74],
  })),
  navBox: css(
    mq({
      position: "fixed",
      right: "60px",
    })
  ),
  logo: css(mq({
  })),
  logoImg: css(mq({
    display: "block",
    height: [30, null, 50],
    transition: "all .2s",
    // marginTop: ["3rem", null, "5.5rem"],
  })),
  logoScrolled: css(mq({
    transition: "all 0.3s",
    display: "block",
    height: [30, null, 40],
  })),
}